import { MfaSetupDetails } from './mfa-setup-details';

export class MfaVerificationCode extends MfaSetupDetails {

	code: string;
	rememberMe: boolean;

	constructor() {
		super();
	}
}
